goog.provide("shadow.js.shim.module$src$svg$editor$emoji$thumbs_up_svg");
goog.provide("module$shadow_js_shim_module$src$svg$editor$emoji$thumbs_up_svg");
shadow.js.shim.module$src$svg$editor$emoji$thumbs_up_svg = shadow.js.nativeProvides["src/svg/editor/emoji/thumbs-up.svg"] = shadow$bridge("src/svg/editor/emoji/thumbs-up.svg");
module$shadow_js_shim_module$src$svg$editor$emoji$thumbs_up_svg.default = shadow.js.shim.module$src$svg$editor$emoji$thumbs_up_svg;
